(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SimpleKeyboardLayouts", [], factory);
	else if(typeof exports === 'object')
		exports["SimpleKeyboardLayouts"] = factory();
	else
		root["SimpleKeyboardLayouts"] = factory();
})(this, function() {
return 